import { FC } from "react";
import { useAppSelector } from "@/store/hooks";
import { TrendColumnHeaderCell } from "@/components/pages/resource-explorer/components/resource-explorer-card/components/billing-explorer-data-grid/components/header-cell-components/TrendColumnHeaderCell";
import { billingExplorerWidgetSetupTableTrendSelector } from "@/store/dashboards/selectors/widgets/billing-explorer-widget/setup/billingExplorerWidgetSetupTableTrendSelector";

export const BillingExplorerWidgetSetupTableTrendHeaderCell: FC = () => {
  const trend = useAppSelector(billingExplorerWidgetSetupTableTrendSelector);
  return <TrendColumnHeaderCell trend={trend} />;
};
